import cx from 'classnames'
import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import IconCheckSmall from '@adv-mt/mt-svg-icons/lib/CheckSmall.js'
import IconCloseSmall from '@adv-mt/mt-svg-icons/lib/CloseSmall.js'
import {Icon, ICON_INTENTS, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body1, Body2} from '@adv-mt/ui/typography'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'
import BaseDrawer from '../BaseDrawer/index.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-rentingServicesDrawer`

const RentingServicesDrawer = ({onClose, services = []}) => {
  const {i18n} = useSuiContext()

  return (
    <BaseDrawer onClose={onClose} title={i18n.t('DEALER_SERVICE.DEALER_SERVICES_SUBSCRIPTION_TITLE')}>
      <ul className={BASE_CLASS}>
        {services.map(({description, isIncluded, title, type}) => {
          // The backend does not always return the field, so only an explicit false means the service is excluded
          const isNotIncluded = isIncluded === false
          const ServiceIcon = isNotIncluded ? IconCloseSmall : IconCheckSmall

          return (
            <li className={`${BASE_CLASS}-item`} key={type}>
              <Icon size={ICON_SIZES.MD} intent={ICON_INTENTS.PRIMARY}>
                <ServiceIcon size={ICON_SIZES.MD} />
              </Icon>
              <div className={`${BASE_CLASS}-itemText`}>
                <Body1 className={cx(isNotIncluded && `${BASE_CLASS}-itemTitle--notIncluded`)} highlight>
                  {title}
                </Body1>
                {Boolean(description) && <Body2>{description}</Body2>}
              </div>
            </li>
          )
        })}
      </ul>
    </BaseDrawer>
  )
}

RentingServicesDrawer.displayName = 'RentingServicesDrawer'

RentingServicesDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  services: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      isIncluded: PropTypes.bool,
      title: PropTypes.string,
      type: PropTypes.string
    })
  )
}

export default RentingServicesDrawer
